import React from 'react';
import { Paper, Stack, Typography } from "@mui/material";

import WifiIcon from "@mui/icons-material/Wifi";
import SignalWifiStatusbarNullIcon from "@mui/icons-material/SignalWifiStatusbarNull";

import HighlightRoundedIcon from "@mui/icons-material/HighlightRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import VolumeMuteRoundedIcon from "@mui/icons-material/VolumeMuteRounded";

// import Heli from "../../images/SVG/Heli.svg";
import Heli from "../../images/SCADA/HelicopterCorridorLight.svg";


// import MarineAidSystemIcon from "../../images/SVG/MarineLantern.svg";
import MarineAidSystemIcon from "../../images/SCADA/MarineLantern.svg"

//import VisibilitySensorIcon from "../../images/SVG/VisibilityRing.svg";
import VisibilitySensorIcon from "../../images/SCADA/VisibilitySensor.svg"

import SensorsIcon from '@mui/icons-material/Sensors';
//import WindTurbineImage from "../../images/SCADA/WindTurbineWithContainer.svg";

//import WindTurbineImage from "../../images/SCADA/WTF_Foghorn.svg";
// import WindTurbineImage from "../../images/SVG/windturbine1.1.svg"
// import {ReactComponent as WindTurbineImage} from "../../images/SVG/windturbine1.2.svg"

// import WindTurbineImage from "../../images/SCADA/WindTurbineWithIcons.svg"
import { Brightness1 } from "@mui/icons-material";
import TurbineImage from "./Icons/Turbine.js"



const green = '#00c853';
const yello = '#ffab00';
const red = '#dd2c00';
const backgroundColor="#455a64"
const PaperColor="#37474f";

const PaperOutStyle={
  opacity:"0.98",
  bgcolor:PaperColor ,  borderRadius:"20px", padding:"2px",paddingBottom:"-10px", paddingTop:"10px",
}
const PaperIntyle={
  bgcolor:PaperColor,
  opacity:"0.98",
}



const IconType = {
  Light: 1,
  Sound: 2
}

const LightIcon = {
  ON: <HighlightRoundedIcon sx={{color:"white"}} />,
  
  OFF: <HighlightOffRoundedIcon sx={{color:"white"}}/>,
};

const SoundIcon = {
  ON: <VolumeUpRoundedIcon sx={{color:"white"}}/>,
  OFF: <VolumeMuteRoundedIcon sx={{color:"white"}}/>,
};

export function AidEqipmentInfo(turbineData) {
  return (
    <>
      <Stack direction="row" margin={"50px"} marginTop="-20px">
        <Stack style={{ marginRight: "40px", marginTop:"70px" }} spacing={10} minWidth={"350px"}>
        
        {turbineData.visibilitySensor.visible ? (
          <Paper elevation={5} sx={PaperOutStyle}>

              <>
                {EquipmentGroupeText("Aviation Aid Equipment", "10px")}
                {AidEquipmentTable(
                  VisibilitySensorIcon,
                  "Visibility Sensor",
                  turbineData.visibilitySensor,
                  IconType.Light
                )}
              </>
          </Paper>
           ) : null}
             
         {turbineData.marineLanterns.visible?
        ( 
        <Paper elevation={5} sx={PaperOutStyle} >
         { EquipmentGroupeText("  Marine Aid Equipment", "0px")}
            
            {turbineData.marineLanterns.visible
              ? (
                  AidEquipmentTable(
                  MarineAidSystemIcon,
                  "Marine Lantern",
                  turbineData.marineLanterns,
                  IconType.Light
                )
                )
              : null}
            {turbineData.marineHelicopterCorridorLights.visible
              ? AidEquipmentTable(
                  Heli,
                  "Helicopter Corridor Lights",
                  turbineData.marineHelicopterCorridorLights,
                  IconType.Light
                )
              : null}
          </Paper>
        ):null}    
        </Stack>
        <Stack >

         <TurbineImage  turbineData={turbineData}/>

        </Stack>
      </Stack>
      
    </>
  );
}

function AidEquipmentTable(
  Icon,
  Text,
  TurbineData,
  IconType
) {
  
  debugger

  const availability = TurbineData.status;
  /**
   * Needs a new parameter, to indicate if active.
   */
  const status = TurbineData.state;

  const iconGroup = IconType ? LightIcon : SoundIcon;

  /**
   * Amount of equipment is configured here
   */
  let amount = null;
  let typeAmount = TurbineData.amount.toLowerCase();
  
  if (typeAmount === "x") {
    amount = 1
  } else {
    amount = typeAmount.slice(0, 1);
  }

  return (
    <Paper elevation={5} sx={PaperIntyle}>
      <Stack
        direction="row"
        style={{
          marginTop: "8px",
          marginLeft: "8px",
          marginRight: "10px",
        }}
      >
        <img src={Icon} alt="logo" width={"50px"} height={"50px"}/>
        <Stack>
          <Typography
            style={{ fontSize: "18px", fontWeight: "bold", width: "280px" ,opacity:"1",}}
            variant="h6"
            color="white"
            gutterBottom
            align="left"
          >
            {Text}
          </Typography>
          <Stack direction="row" justifyContent="space-between">
            <Typography
              style={{ fontSize: "18px" ,opacity:"1", }}
              variant="h6"
              gutterBottom
              color="white"
              align="left"
            >
              Availability: {availability ? "Offline" : "Online"}
              <br />
              Status: {status ? "Inactive" : "Active"}
              <br />
              Amount: {amount}
            </Typography>
            <Stack spacing={1}>
              {availability ? <SignalWifiStatusbarNullIcon sx={{color:"white", opacity:"1",}}/> : <WifiIcon sx={{color:"white", opacity:"1",}}/>}
              {status ? (
                iconGroup.OFF
              ) : (
                iconGroup.ON
              )}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  )
}

function EquipmentGroupeText(Text, marginTop) {
  return (
    <Typography
      style={{ opacity:"1", marginTop: marginTop, fontWeight: "600" }}
      variant="h6"
      color="white"
      gutterBottom
    >
      {Text}
    </Typography>
  )
}
EquipmentGroupeText.defaultProps = {
  Text: "Missing equipment",
  marginTop: "10px",
}
